import * as React from 'react';
import { observer } from 'mobx-react';
import AlertTable from '~/components/AlertTable';
import { useStores } from '~store/utils';
import { useSiteConfiguration, deviceVerificationEnabled } from '~containers/ConfigurationForm/ConfigurationForm';

const DashboardAlertListContainer: React.FC = observer(() => {
  const { alerts: alertsStore, sites } = useStores();
  const { data: siteConfig } = useSiteConfiguration(sites.selectedSite?.uuid ?? null);
  const deviceVerification = deviceVerificationEnabled(siteConfig);

  const alerts = alertsStore.alertsSorted;
  const combinedAlerts = [...alerts.filter((val) => val.isOpen), ...alerts.filter((val) => !val.isOpen).slice(0, 15)];
  return <AlertTable alerts={combinedAlerts} deviceVerification={deviceVerification} />;
});

export default DashboardAlertListContainer;
